import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiSearchSuggestParams,
  BackendErrorEntity,
  SearchSuggestResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiSearchSuggest = (
    params: MaybeRef<ApiSearchSuggestParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<SearchSuggestResponseDto>(
      {url: `/search/suggest`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiSearchSuggestQueryKey = (params: MaybeRef<ApiSearchSuggestParams>,) => {
    return ['search','suggest', ...(params ? [params]: [])] as const;
    }

    
export const getApiSearchSuggestQueryOptions = <TData = Awaited<ReturnType<typeof apiSearchSuggest>>, TError = ErrorType<BackendErrorEntity>>(params: MaybeRef<ApiSearchSuggestParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiSearchSuggest>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiSearchSuggestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSearchSuggest>>> = () => apiSearchSuggest(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiSearchSuggest>>, TError, TData> 
}

export type ApiSearchSuggestQueryResult = NonNullable<Awaited<ReturnType<typeof apiSearchSuggest>>>
export type ApiSearchSuggestQueryError = ErrorType<BackendErrorEntity>



export function useApiSearchSuggest<TData = Awaited<ReturnType<typeof apiSearchSuggest>>, TError = ErrorType<BackendErrorEntity>>(
 params: MaybeRef<ApiSearchSuggestParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiSearchSuggest>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiSearchSuggestQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



